/**
 * Utility functions for formatting data in the Suporte Dashboard
 */

/**
 * Format a number with thousand separators
 * @param {number} value - The number to format
 * @returns {string} - Formatted number string
 */
export const formatNumber = (value) => {
  if (value === undefined || value === null) return "0";
  
  return new Intl.NumberFormat('pt-BR').format(value);
};

/**
 * Format time in minutes to a readable format (Xh Ym)
 * @param {number} minutes - Time in minutes
 * @returns {string} - Formatted time string
 */
export const formatTime = (minutes) => {
  if (minutes === undefined || minutes === null) return "0m";
  
  const hrs = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return hrs > 0 ? `${hrs}h ${mins}m` : `${mins}m`;
};

/**
 * Format a percentage value
 * @param {number} value - The percentage value
 * @returns {string} - Formatted percentage string
 */
export const formatPercentage = (value) => {
  if (value === undefined || value === null) return "0%";
  
  return `${value}%`;
};
